import { call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import digitalTwinServices from '../api/digitalTwin';
import { digitalTwinActions } from '../reducers/digital-twin';



function* digitalTwinListRequest({ payload }: any): any {
  const res = yield call(digitalTwinServices.fetchDigitalTwinList, payload);
  if (res.status === 'success') {
    yield put(digitalTwinActions.getDigitalTwinDataResponse(res));
  } else {
    yield put(digitalTwinActions.getDigitalTwinDataFailed(res?.code));
  }
}

function* addDigitalTwin({ payload }: any): any {
  const res = yield call(digitalTwinServices.addDigitalTwin, payload);
  if (res.status === 'success') {
    yield put(digitalTwinActions.addDigitalTwinResponse(res?.code));
  } else {
    yield put(digitalTwinActions.addDigitalTwinFailed(res?.code));
  }
}

function* updateDigitalTwin({ payload }: any): any {
  const res = yield call(digitalTwinServices.updateDigitalTwin, payload);
  if (res.status === 'success') {
    yield put(digitalTwinActions.updateDigitalTwinResponse(res?.code));
  } else {
    yield put(digitalTwinActions.updateDigitalTwinFailed(res?.code));
  }
}

function* removeDigitalTwin({ payload }: any): any {
  const res = yield call(digitalTwinServices.removeDigitalTwin, payload);
  if (res.status === 'success') {
    yield put(digitalTwinActions.removeDigitalTwinResponse(res?.code));
  } else {
    yield put(digitalTwinActions.removeDigitalTwinFailed(res?.code));
  }
}

function* sceneDataRequest({ payload }: any): any {
  const res = yield call(digitalTwinServices.fetchDigitalTwinScene, payload);
  if (res.status === 'success') {
    yield put(digitalTwinActions.sceneDataResponse(res));
  } else {
    yield put(digitalTwinActions.sceneDataFailed(res?.code));
  }
}

function* libraryDataRequest({ payload }: any): any {
  const res = yield call(digitalTwinServices.fetchDigitalTwinLibrary, payload);
  if (res.status === 'success') {
    yield put(digitalTwinActions.libraryDataResponse(res));
  } else {
    yield put(digitalTwinActions.libraryDataFailed(res?.code));
  }
}

function* digitalTwinSaga() {
  yield takeLatest('digitalTwin/getDigitalTwinListRequest', digitalTwinListRequest);
  yield takeLeading('digitalTwin/addDigitalTwinRequest', addDigitalTwin);
  yield takeLeading('digitalTwin/removeDigitalTwinRequest', removeDigitalTwin);
  yield takeLeading('digitalTwin/updateDigitalTwinRequest', updateDigitalTwin);
  yield takeLatest('digitalTwin/sceneDataRequest', sceneDataRequest);
  yield takeLatest('digitalTwin/libraryDataRequest', libraryDataRequest);
}

export default digitalTwinSaga;
